import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";

const EMPTY = { name: "", designation: "", phone: "", email: "", linkedin: "", modes: [] };
const MODES = ["Email", "LinkedIn", "WhatsApp"];

const Field = ({ label, children }) => (
  <label className="block">
    <span className="text-xs font-medium text-slate-500">{label}</span>
    {children}
  </label>
);
const inputCls = "mt-1 w-full h-11 px-3 rounded-xl border border-slate-300 text-sm outline-none focus:border-slate-500";

export const ContactDialog = ({ contact, onClose, onSave, saving }) => {
  const [c, setC] = useState({ ...EMPTY, ...(contact || {}) });
  const set = (k) => (e) => setC((x) => ({ ...x, [k]: e.target.value }));
  const toggle = (m) => setC((x) => ({ ...x, modes: x.modes.includes(m) ? x.modes.filter((y) => y !== m) : [...x.modes, m] }));
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent data-testid="contact-dialog" className="rounded-2xl sm:max-w-lg">
        <DialogHeader><DialogTitle className="text-xl">{contact?.id ? "Edit contact" : "Add contact"}</DialogTitle></DialogHeader>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
          <Field label="Name"><input data-testid="contact-name" value={c.name} onChange={set("name")} className={inputCls} /></Field>
          <Field label="Designation"><input data-testid="contact-designation" value={c.designation} onChange={set("designation")} className={inputCls} /></Field>
          <Field label="Phone / WhatsApp"><input data-testid="contact-phone" value={c.phone} onChange={set("phone")} placeholder="+49 …" className={inputCls} /></Field>
          <Field label="Email"><input data-testid="contact-email" type="email" value={c.email} onChange={set("email")} className={inputCls} /></Field>
          <div className="sm:col-span-2"><Field label="LinkedIn profile link"><input data-testid="contact-linkedin" value={c.linkedin} onChange={set("linkedin")} placeholder="https://www.linkedin.com/in/…" className={inputCls} /></Field></div>
        </div>
        <div>
          <span className="text-xs font-medium text-slate-500">Preferred mode</span>
          <div className="flex gap-2 mt-1">
            {MODES.map((m) => {
              const on = c.modes.includes(m);
              return (
                <button key={m} type="button" data-testid={`contact-mode-${m.toLowerCase()}`} aria-pressed={on} onClick={() => toggle(m)}
                  className={`h-10 px-4 rounded-full text-sm font-medium border transition-colors ${on ? "bg-emerald-600 text-white border-emerald-600" : "bg-white text-slate-700 border-slate-300"}`}>
                  {m}
                </button>
              );
            })}
          </div>
        </div>
        <div className="flex justify-end gap-2 pt-2">
          <Button variant="ghost" onClick={onClose} className="h-11 rounded-xl">Cancel</Button>
          <Button data-testid="contact-save" disabled={saving} onClick={() => onSave(c)} className="h-11 px-6 rounded-xl bg-slate-900 hover:bg-slate-800">
            {saving ? "Saving…" : "Save"}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
